import { render, staticRenderFns } from "./transactionVerifier.vue?vue&type=template&id=458d1d19&scoped=true"
import script from "./transactionVerifier.vue?vue&type=script&lang=js"
export * from "./transactionVerifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d1d19",
  null
  
)

export default component.exports